import { isActionable, isAdoptable, type SyncStatus } from '../../domain/status.js';

/**
 * What the drawer's footer offers for the environment the field diff is focused on — pure, so
 * the rule is tested without a drawer, and decided ONCE for both buttons. **Push to <env>** where
 * a push would write there (`drift` or `missing`) and the host page can push; **Adopt** where the
 * environment holds something master doesn't (`env_only`) or a different value (`drift`) — the
 * same two conditions the per-environment table's row buttons use. With no environment focused,
 * or nothing to do there, the footer is not rendered: no permanently disabled button on screen.
 */
export type DrawerFooterInput = { focus: string | undefined; status: SyncStatus | undefined; canPush: boolean };
export type DrawerFooter = { environment: string; push: boolean; adopt: boolean };

export const drawerFooter = (i: DrawerFooterInput): DrawerFooter | null => {
    if (!i.focus || !i.status) return null;
    const push = i.canPush && isActionable(i.status);
    const adopt = isAdoptable(i.status);
    return push || adopt ? { environment: i.focus, push, adopt } : null;
};
